import React from "react"
import { Card, CardHeader, CardText } from "material-ui/Card"
import Paper from "material-ui/Paper"
interface IProps {
	expanded: boolean
	handleExpandChange(): void
	cardLabel: string
	children: any
}

const SettingsCard: React.SFC<IProps> = (props: IProps) => {
	return (
		<Paper zDepth={1} style={{ marginBottom: 20 }}>
			<Card data-intercom-target={`menu-AccountSettings-${props.cardLabel}-Tab`} expanded={props.expanded} onExpandChange={props.handleExpandChange}>
				<CardHeader title={props.cardLabel} showExpandableButton={true} actAsExpander={true} />
				<CardText expandable={true}>{props.children}</CardText>
			</Card>
		</Paper>
	)
}

export default SettingsCard
